import { Component, Input } from '@angular/core';

@Component({
  selector: 'site-indexMobileContentLeft',
  templateUrl: './indexMobileContentLeft.component.html',
  styleUrls: ['./indexMobileContentLeft.component.css']
})
export class IndexMobileContentLeft {
  @Input()
  articleTypeSubHeader;
  @Input()
  indexMobileHeader;
  @Input()
  pageRouteType;
  @Input()
  contentAreaImage;

  @Input()
  seeAllBoxType: string;
  @Input()
  content1Name: string;
  @Input()
  content2Name: string;
  @Input()
  content3Name: string;
  @Input()
  content4Name: string;
  @Input()
  section1ID: number;
  @Input()
  pageRouteType1: string;
  @Input()
  section2ID: number;
  @Input()
  pageRouteType2: string;
  @Input()
  section3ID: number;
  @Input()
  pageRouteType3: string;
  @Input()
  section4ID: number;
  @Input()
  pageRouteType4: string;
  @Input()
  longSectionLink: string;
  @Input()
  content1Image: string;
  @Input()
  content2Image: string;
  @Input()
  content3Image: string;
  @Input()
  content4Image: string;
  
}



// WEBPACK FOOTER //
// /home/ppeters/filmCritClient/src/app/components/indexMobileContentLeft/indexMobileContentLeft.component.ts